module.exports = __webpack_public_path__ + "static/media/2.b577be07.jpg";